import React, { useEffect, useState } from "react";
import Title from "../../components/common/Title";
import { Topbar } from "../../components/include/Topbar";
import { useNavigate } from "react-router-dom";
import { EyeIcon } from "@heroicons/react/20/solid";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { useDispatch, useSelector } from "react-redux";
import { message } from "../../redux/actions/toastActions";
import Page from "../../helpers/config";
import Pagination from "../../components/common/Pagination";
import DeleteModal from "../../components/common/DeleteModal";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";
import axios from "axios";

const SchoolList = () => {
  const [data, setData] = useState([]);
  const [totalCredits, setTotalCredits] = useState(0);
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const dispatch = useDispatch();
  const [refresh, setRefresh] = useState(false);
  const [loader, setLoader] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(Page.records);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalOpenDelete, setModalOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [hasFetched, setHasFetched] = useState(false);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  const isAccessible = role === "admin" || role === "subadmin" || permissions?.includes("view_School");
  const isEditable = role === "admin" || role === "subadmin" || permissions?.includes("edit_School");
  const isDeletable =
    role === "admin" || role === "subadmin" || permissions?.includes("delete_School");

  useEffect(() => {
    const fetchSearchResults = async () => {
      setLoader(true);
      try {
        Postdata(HttpService.admin_search_school_list, {
          search: searchQuery,
        }).then((res) => {
          if (res.status === 200) {
            setData(res.data.schools);
            setTotalRows(res.data.count);
            setTotalCredits(res.data.totalCredits || 0);
          }
        });
      } catch (error) {
        console.error("Error fetching search results:", error);
      } finally {
        setLoader(false);
      }
    };

    const timer = setTimeout(() => {
      fetchSearchResults();
    }, 500); // Debounce the search to only trigger after 500ms

    return () => clearTimeout(timer); // Cleanup timer on component unmount or change in searchQuery
  }, [searchQuery]);

  useEffect(() => {
    localStorage.removeItem("mode");
    localStorage.removeItem("activeCountryCode");
  }, []);

  // Pagination handlers
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchData(page, perPage);
  };

  const handleRowsPerPageChange = (rows) => {
    setPerPage(rows);
    setCurrentPage(1);
    fetchData(1, rows);
  };

  // Handle delete functionality
  const handleDelete = (id) => {
    setLoader(true);
    Postdata(HttpService.admin_school_delete, { id }).then((res) => {
      if (res.status === 200) {
        // dispatch(message(res.message));
        setRefresh(!refresh);
      }
      // dispatch(message(res.message));
      setLoader(false);
    });
  };

  // Toggle school status (active/inactive)
  // const handleStatusToggle = (id) => {
  //   Postdata(HttpService.admin_school_status_update, { id, type: "status" }).then((res) => {
  //     if (res.status === 200) {
  //       setRefresh(!refresh);
  //     }
  //     // dispatch(message(res.message));
  //   });
  // };

  const handleStatusToggle = async (id) => {
    try {
      const res = await axios.post(
        HttpService.admin_school_status_update,
        {
          id,
          type: "status",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res.status === 200) {
        setRefresh((prev) => !prev);
      }
    } catch (error) {
      console.error("Status toggle failed", error);
    }
  };

  const handleColorManagementToggle = async (id) => {
    try {
      const res = await axios.post(
        HttpService.admin_school_status_update,
        {
          id,
          type: "color_managenment",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res.status === 200) {
        setRefresh((prev) => !prev);
      }
    } catch (error) {
      console.error("Color management toggle failed", error);
    }
  };


  // Fetch schools data
  const fetchData = (currentPage, perPage) => {
    setLoader(true);

    Postdata(HttpService.admin_school_list, {
      page: currentPage,
      perpage: perPage,
    })
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.schools);
          setTotalRows(res.data.count);
          setTotalCredits(res.data.totalCredits || 0);
        }
        // else {
        //     dispatch(message(res.message));
        // }
        setHasFetched(true);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    fetchData(currentPage, perPage);
  }, [refresh, currentPage, perPage]);


  if (!isAccessible) {
    return <Error403Page />;
  }

  return (
    <>
      <Title name="School List" />
      <Topbar title="School List" />
      <div className="p-6 space-y-6 pr-0">
        <div className="flex items-center gap-2">
          <span className="text-gray-500 text-sm font-medium">Total Credits:</span>
          <span className="bg-primary_main text-white text-sm font-bold px-3 py-1 rounded-full">
            {totalCredits?.toLocaleString()}
          </span>
        </div>
        <div className=" flex justify-end">
          <input
            type="text"
            placeholder="Search schools, email..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
            }}
            className="px-4 py-2 mr-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none w-72"
          />
          <div className="">
            {isEditable && (
              <button
                className="bg-primary_main text-white px-4 py-2 rounded hover:bg-primary_dark"
                onClick={() => navigate("admin-school/add")}
              >
                + Add School
              </button>
            )}
          </div>
        </div>
        <div className="bg-white rounded overflow-x-auto p-2">
          <table className="min-w-full text-sm text-left">
            <thead className="text-gray-700">
              <tr>
                <th className="px-6 py-3 font-medium">Name</th>
                <th className="px-6 py-3 font-medium">Email</th>
                <th className="px-6 py-3 font-medium">Sub-Domain</th>
                {isEditable && (
                  <>
                    <th className="px-6 py-3 font-medium">Status</th>
                    <th className="px-6 py-3 font-medium">Color Management</th>
                  </>
                )}
                <th className="px-6 py-3 font-medium">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {loader || !hasFetched ? (
                <tr>
                  <td colSpan="5" className="text-center py-4">
                    <div className="loader">Loading...</div>
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4">{item.name}</td>
                    <td className="px-6 py-4">{item.email}</td>
                    <td className="px-6 py-4">{item.subdomain || "-"}</td>
                    <td className="px-6 py-4">
                      {isEditable ? (
                        <label className="inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={item.status === 1}
                            onChange={() => handleStatusToggle(item._id)}
                          />
                          <div
                            className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary_main rounded-full peer
                                                        peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px]
                                                        after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all
                                                        peer-checked:bg-primary_main"
                          ></div>
                        </label>
                      ) : item.status === 1 ? (
                        "Active"
                      ) : (
                        "Inactive"
                      )}
                    </td>
                    {/* Color Management Toggle */}
                    {isEditable && (
                      <td className="px-6 py-4">
                        <label className="inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={item.color_managenment === 1}
                            onChange={() =>
                              handleColorManagementToggle(item._id)
                            }
                          />
                          <div
                            className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary_main rounded-full peer
                                peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px]
                                after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all
                                peer-checked:bg-primary_main"
                          ></div>
                        </label>
                      </td>
                    )}
                    <td className="px-6 py-4 space-x-3">
                      <button
                        className="text-black hover:underline"
                        onClick={() => {
                          localStorage.setItem("mode", "view");
                          navigate(`admin-school/view/${item._id}`);
                        }}
                      >
                        View
                      </button>
                      {isEditable && (
                        <button
                          className="text-primary_main hover:underline"
                          onClick={() => {
                            localStorage.removeItem("mode"); // ✅ FIX
                            navigate(`admin-school/edit/${item._id}`, {
                              state: { type: "edit" },
                            });
                          }}
                        >
                          Edit
                        </button>
                      )}
                      {isDeletable && (
                        <button
                          className="text-red-600 hover:underline"
                          onClick={() => {
                            setSelectedId(item._id);
                            setModalOpenDelete(true);
                          }}
                        >
                          Delete
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {!loader && data !== null && hasFetched && data.length === 0 && (
            <div className="h-[50vh] flex items-center justify-center w-full">
              <h1 className="text-center text-gray-400">No Data Found</h1>
            </div>
          )}
        </div>

        <Pagination
          currentPage={currentPage}
          totalRows={totalRows}
          perPage={perPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          type=""
        />

        <DeleteModal
          title="Delete School"
          message="Are you sure you want to delete School? It will erase all the data permanently."
          modalOpenDelete={modalOpenDelete}
          setmodalOpenDelete={setModalOpenDelete}
          handleDelete={handleDelete}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          modalOpenDeleteSuccess={modalOpenDeleteSuccess}
          setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
          module={"School"}
          redirectPage={"School Management"}
          redirectUrl={"admin-school"}
        />
      </div>
    </>
  );
};

export default SchoolList;
